module.exports = __webpack_public_path__ + "static/media/fake-friends-potion.aaebdadf.png";